import { render, staticRenderFns } from "./TopicFooter.vue?vue&type=template&id=48de75f8&lang=pug"
import script from "./TopicFooter.vue?vue&type=script&lang=ts"
export * from "./TopicFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports